import { Inject, Injectable } from '@angular/core';
import { DomService } from '../../library/dom.service';

@Injectable()
export class EchatService {
  constructor(private domService: DomService, @Inject('EnvironmentProvider') private environmentProvider) {}

  openEchat(scenarioId: string, reason?: string) {
    this.openEchatNewton(scenarioId, reason);
  }

  openEchatNewton(scenarioId: string, reason?: string) {
    const reasonParameter = reason ? '?reason=' + encodeURIComponent(reason.replace(/'/g, ' ')) : '';
    const url = this.environmentProvider.urlEchatNewtonByECE + scenarioId + '/init' + reasonParameter;
    window.open(url, '_blank', this.getEchatWindowFeatureConfig());
  }

  private getEchatWindowFeatureConfig(): string {
    const screenWidth = screen.width;
    const screenHeight = screen.height;
    const echatWidth = 410;
    const echatHeight = 410;
    const echatLeft = (screenWidth - echatWidth) / 2;
    const echatTop = (screenHeight - echatHeight) / 2;
    const windowFeature = `width=${echatWidth}px, height=${echatHeight}px, top=${echatTop}, left=${echatLeft}, resizable=1`;
    return windowFeature;
  }
}
